export enum ModuleType {
  qna = 'qna',
  review = 'review',
}

export const setLoadTime = type => {
  performance.mark(type);
};
